import './styles.scss';

import axios from 'axios';
import React from 'react';
import { toast as Toast } from 'react-toastify';
import { Button } from 'reactstrap';

import ToastContent from '@/components/toasts/content';
import { Constants } from '@/constants';

const ActionPage = () => {
  const syncFeed = async () => {
    try {
      const res = await axios.post(`${Constants.apiPath}/feed/cache`);
      console.log(res.data);

      Toast.success(
        <ToastContent message="Successfully updated feed!" title="Feed Sync" />,
        {
          position: 'top-right',
        }
      );
    } catch (e: any) {
      console.error(e.message);

      Toast.error(<ToastContent message={e.message} title="Feed Sync" />, {
        position: 'top-right',
      });
    }
  };
  return (
    <>
      <Button onClick={syncFeed}>Sync Feed</Button>
    </>
  );
};

export default ActionPage;
